import React, { useRef, useEffect, useState } from 'react';
import maplibregl from 'maplibre-gl';
import { useSelector } from 'react-redux';
//import './maplibre-gl.css';
// import './Map.css';
import partnerMarker from '../../assets/partnerMarker.png';
import lpMarker from '../../assets/lpMarker.png';
import star from '../../assets/star2.png';

const Map = () => {
    const projectState = useSelector(state => state.project);
    const mapContainer = useRef(null);
    const map = useRef(null);
    const lng = projectState.mapCenter[0];
    const lat = projectState.mapCenter[1];
    const [zoom] = useState(7);

    const addMarker = (geoJson) => {
        const leadPartnerFeature = geoJson.features.find(f => f.properties.isLeadPartner);
        if (leadPartnerFeature) {
            let lpIcon = document.createElement('div');
            lpIcon.className = 'lead-partner';
            lpIcon.style.backgroundImage = `url(${star})`;
            new maplibregl.Marker(lpIcon, {
                offset: [-10, -10]
            })
                .setLngLat(leadPartnerFeature.geometry.coordinates)
                .addTo(map.current);
        }
        adjustDisplay(geoJson.features.map(marker => marker.geometry.coordinates));
    }

    const createSvgMarker = (color) => {
        const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="36" viewBox="0 0 24 36">
            <path d="M12 0C5.373 0 0 5.373 0 12c0 9 12 24 12 24s12-15 12-24C24 5.373 18.627 0 12 0z" fill="${color}" stroke="#ffffff" stroke-width="1.5"/>
            <circle cx="12" cy="12" r="5" fill="#ffffff"/>
        </svg>`;
        return new Promise((resolve) => {
            const img = new Image(24, 36);
            img.onload = () => {
                const canvas = document.createElement('canvas');
                canvas.width = 24;
                canvas.height = 36;
                const ctx = canvas.getContext('2d');
                ctx.drawImage(img, 0, 0);
                resolve(ctx.getImageData(0, 0, 24, 36));
            };
            img.src = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svg);
        });
    }

    const addMarkerImages = async () => {
        map.current.loadImage(partnerMarker, (error, image) => {
            if (error) console.error(error);
            map.current.addImage('partnerMarker', image);
        });
        map.current.loadImage(lpMarker, (error, image) => {
            if (error) console.error(error);
            map.current.addImage('lpMarker', image);
        });
        map.current.loadImage(star, (error, image) => {
            if (error) console.error(error);
            map.current.addImage('star', image);
        });
        const capCallMarkerData = await createSvgMarker('#f1c232');
        map.current.addImage('capCallMarker', capCallMarkerData, { width: 24, height: 36 });
        const capCallExistingMarkerData = await createSvgMarker('#9b59b6');
        map.current.addImage('capCallExistingMarker', capCallExistingMarkerData, { width: 24, height: 36 });
    }

    const addSource = (geoJson) => {
        map.current.addSource('partners', {
            type: 'geojson',
            data: geoJson,
            cluster: true,
            clusterMaxZoom: 20,
            clusterRadius: 15,
            clusterProperties: {
                hasYellow: ['any', ['==', ['get', 'color'], '#f1c232']],
                hasPurple: ['any', ['==', ['get', 'color'], '#9b59b6']]
            }
        });
    }

    const addClusters = () => {
        map.current.addLayer({
            id: 'clusters',
            type: 'circle',
            source: 'partners',
            filter: ['has', 'point_count'],
            paint: {
                'circle-color': [
                    'case',
                    ['get', 'hasYellow'], '#f1c232',
                    ['get', 'hasPurple'], '#9b59b6',
                    '#609bc4'
                ],
                'circle-radius': [
                    'step',
                    ['get', 'point_count'],
                    15,
                    2,
                    15,
                    3,
                    15
                ]
            }
        });
    }

    const addClusterCount = () => {
        map.current.addLayer({
            id: 'cluster-count',
            type: 'symbol',
            source: 'partners',
            filter: ['has', 'point_count'],
            layout: {
                'text-field': '{point_count_abbreviated}',
                'text-font': ['Noto Sans Regular'],
                'text-size': 14,
                'text-allow-overlap': true
            },
            paint: {
                "text-color": "#ffffff"
              }

        });
    }

    const addUnclusteredPoints = () => {
        map.current.addLayer({
            id: 'unclustered-point',
            type: 'symbol',
            source: 'partners',
            filter: ['!', ['has', 'point_count']],
            layout: {
                'icon-image': [
                    'case',
                    ['==', ['get', 'color'], '#f1c232'], 'capCallMarker',
                    ['==', ['get', 'color'], '#9b59b6'], 'capCallExistingMarker',
                    'partnerMarker'
                ],
                'icon-allow-overlap': true
            }
        });
    }


    const adjustDisplay = (coord) => {
        let max = [-180, -180];
        let min = [180, 180];
        let minLat = coord.map(pt => Number(pt[0]));
        let minLng = coord.map(pt => Number(pt[1]));
        let maxLat = coord.map(pt => Number(pt[0]));
        let maxLng = coord.map(pt => Number(pt[1]));
        min = [Math.min(...minLat), Math.min(...minLng)];
        max = [Math.max(...maxLat), Math.max(...maxLng)];
        map.current.fitBounds([min, max], { maxZoom: 10, padding: { top: 180, bottom: 180, left: 180, right: 180 } });
    }

    useEffect(() => {
        if (map.current) return; //stops map from intializing more than once
        map.current = new maplibregl.Map({
            container: mapContainer.current,
            style: `https://carto.hex-it.ovh/styles/basic-preview/style.json`,
            center: [lng, lat],
            zoom: zoom,
            preserveDrawingBuffer: true,
        });
        map.current.on('load', async () => {
            addMarker(projectState.markers);
            await addMarkerImages();
            addSource(projectState.markers);
            addClusters();
            addClusterCount();
            addUnclusteredPoints();
        });

    });
    return (
        <div ref={mapContainer} className="map" />
    );
}

export default Map;



